import { application } from "./application"
import controllers from "./**/*_controller.js"
controllers.forEach((controller) => {
  application.register(controller.name, controller.module.default)
})

import { Popover } from "tailwindcss-stimulus-components"
application.register("popover", Popover)

import CustomNestedForm from "./custom_nested_form_controller"
application.register("nested-form", CustomNestedForm)

import RouteBuilderController from "./route_builder_controller"
application.register("route-builder", RouteBuilderController)